import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import Typography from "@mui/material/Typography";
import * as FormDialog from "../../../shared/FormDialog";
import { useUpdateTemplateFormSettings } from "../../../api/templateFormSettings";
import type { QuestionUpdates } from "../../../api/templateFormSettings.types";

type TemplateFormConfirmDialog = {
  id: string;
  onSaved: () => void;
  onCancel: () => void;
  pendingChanges: QuestionUpdates[];
};

export const TemplateFormConfirmDialog: FC<TemplateFormConfirmDialog> = ({ onSaved, onCancel, pendingChanges, id }) => {
  const { t } = useTranslation();
  const { mutate, isPending, isError } = useUpdateTemplateFormSettings();

  const onSave = () => {
    mutate({ id, payload: { questionUpdates: pendingChanges } }, { onSuccess: onSaved });
  };

  return (
    <FormDialog.Dialog isOpen={true}>
      <FormDialog.Title>{t("Template.Form.UpdateDialog.Header")}</FormDialog.Title>
      <FormDialog.Form onSubmit={onSave}>
        <FormDialog.Content>
          <FormDialog.FormError isError={isError} />
          <FormDialog.Fields>
            <FormDialog.Field>
              <Typography>{t("Template.Form.UpdateDialog.Body")}</Typography>
            </FormDialog.Field>
          </FormDialog.Fields>
        </FormDialog.Content>
        <FormDialog.ActionButtons>
          <FormDialog.CancelButton onClick={onCancel} />
          <FormDialog.SubmitButton isSubmitting={isPending}>
            {t("Template.Form.UpdateDialog.UpdateButton")}
          </FormDialog.SubmitButton>
        </FormDialog.ActionButtons>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
